import { SOCIAL_LINKS_API } from "../../../Utilities/APIs"
import BLNCRUD from "../../Partials/Layouts/CRUDs/CRUDLayouts/BLNCRUD/BLNCRUD"

function SocialLinks() {
  return (
    <BLNCRUD
        // common props
        api = {SOCIAL_LINKS_API}
        screenTopicSingular = 'Social Link'
        screenTopicPlural = 'Social Links'
        
        // crud header props
        showTotalInHeading
        
        // crud props
        allowCreate
        allowUpdate
        allowDelete
        
        // field props
        booleanDBField='visibility'
        booleanName='Visibility'
    />
  )
}

export default SocialLinks